module.exports = __webpack_public_path__ + "static/media/me.aae95630.jpeg";